import api from '../services/api';

export default {
  state: {

  },
  mutations: {
  },
  actions: {
    async addToBasket({ commit, state, dispatch }, {productId:productId, quantity:quantity}) {
      try {
        //commit('SET_FAVORITE_LOADING', true);

        const response = await api.post('api/basket/add/', {id: productId,
          quantity: quantity}, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data && response.data.status === 'success') {
          /*if (response.data.data)
            commit('ADD_BASKET', productId);*/

          dispatch('counter/fetchCounterData', true);
        } else {
          throw new Error(response.data.message || 'Ошибка при обновлении избранного');
        }

        //commit('SET_FAVORITE_ERROR', null);
      } catch (error) {
        //commit('SET_FAVORITE_ERROR', error.message || 'Ошибка при обновлении избранного');
        console.error('Error updating favorites:', error);
      } finally {
        //commit('SET_FAVORITE_LOADING', false);
      }
    }
  },
  getters: {

  }
}
